import {
  GET_ORGANISATEURS,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,

  ADD_ORGANISATEUR_SUCCESS,
  ADD_ORGANISATEUR_FAIL,
  
  UPDATE_ORGANISATEUR_SUCCESS,
  UPDATE_ORGANISATEUR_FAIL,
} from "./actionType";

const INIT_STATE = {
  organisateurs: [],
  error: {},
};

const Organisateur = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_ORGANISATEURS:
          return {
            ...state,
            organisateurs: action.payload.data,
            isOrganisateurCreated: false,
            isOrganisateurSuccess: true
          };
        
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_ORGANISATEURS:
          return {
            ...state,
            error: action.payload.error,
            isOrganisateurCreated: false,
            isOrganisateurSuccess: false
          };
        
        default:
          return { ...state };
      }

    case ADD_ORGANISATEUR_SUCCESS:
      return {
        ...state,
        isOrganisateurCreated: true,
        organisateurs: [...state.organisateurs, action.payload.data],
        isOrganisateurAdd: true,
        isOrganisateurAddFail: false
      };

    case ADD_ORGANISATEUR_FAIL:
      return {
        ...state,
        error: action.payload,
        isOrganisateurAdd: false,
        isOrganisateurAddFail: true
      };

    case UPDATE_ORGANISATEUR_SUCCESS:
      return {
        ...state,
        organisateurs: state.organisateurs.map(organisateur =>
          organisateur.id === action.payload.id
            ? { ...organisateur, ...action.payload }
            : organisateur
        ),
        isOrganisateurUpdate: true,
        isOrganisateurUpdateFail: false
      };

    case UPDATE_ORGANISATEUR_FAIL:
      return {
        ...state,
        error: action.payload,
        isOrganisateurUpdate: false,
        isOrganisateurUpdateFail: true
      };

    default:
      return { ...state };
  }
};

export default Organisateur;
